<template>
    <div class="m-width">
        <div class="searchIndex">
            <div class='crumbs-box'>云商城&gt;&gt;产品搜索</div>
            <div class="search_">
                <div class="search align-center search_xs">
                    <input type="text" placeholder="请输入关键词，查找您想要的产品" v-model="search_input">
                    <div class="soudiv" @click="search"><label class="sousuo"></label></div>
                    <div class="maTop13 paLeft30 wordKey"><span>热门关键词：<span @click="keyWords(item)" v-for="(item,i) in keyWordsList" :key="i" class="cursor">{{item}} &nbsp;&nbsp;</span></span></div>
                </div>
                <div>
                    <span class='search_result'>搜索结果&gt;</span><span class='result' v-if='keyId'>系统解决方案</span><span class='result' v-else>{{search_input}}</span>
                </div>

                <div class='goods_padd' v-if="search_input !=''" style="min-height:344px;width: 1220px;">
                    <div class="mall-goods" v-for="(sub,index) in list" >
                        <div class="tit" >
                            <b class='tit_div'>{{sub.Name}}</b>  
                            <div class="maTop">
                                <div class="mall-goods-item" v-for="(item,i) in sub.goods" :key="i" @click="goto(item.Id)">
                                    <div class="goods-pic">
                                        <img :src="item.PicPaths.split(',')[0]"  alt="" />
                                    </div>
                                    <div class="goods-info">
                                        <div class="goods-money"><span>零售价</span>¥ {{item.Price}}</div>
                                        <div class="goods-txt">{{item.Name}}</div>
                                        <div class="goods-handle">
                                            <div class="goods-buy-btn">查看详情&gt;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
                <!--更多-->
                <div class='goods_padd' v-if="keyId !='' && inputs==''" style="width: 1220px;">
                    <div class="mall-goods" v-for="(sub,index) in SystemCaseList" v-if="keyId==sub.StoreTypeId">
                        <div class="tit" >
                            <div>
                                <b class='tit_div'>系统解决方案</b>
                            </div>
                            <div class="maTop">
                                <div class="mall-goods-item">
                                <div class="goods-pic">
                                    <img :src="sub.PicPaths.split(',')[0]"  alt="" />
                                </div>
                                <div class="goods-info">
                                    <div class="goods-money"><span>零售价</span>¥ {{sub.Price}}</div>
                                    <div class="goods-txt">{{sub.Name}}</div>
                                    <div class="goods-handle">
                                        <div class="goods-buy-btn">查看详情&gt;</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div style="height:80px;background: #f5f7fa;"></div>
    </div>
</template>
<script>
import '../../../../html/components/crumbs/crumbs.scss';
import '../../../../html/components/crumbs/crumbs.css';
import '../../../../html/pages/mall/mall/mall.scss';
import '../../../../html/components/searchIndex/searchIndex.css';
import {SearchStore,SystemCase} from '../../../../api/index.js';
export default {
name: 'searchIndex',
    data() {
        return {
            keyWord:'',
            search_input:'',
            list:[],
            keyWordsList:[],
            SystemCaseList:[],
            keyId:'',
            inputs:''
        }
    },
    methods: {
        goto(id) {
            let routeData = this.$router.resolve({ name: 'mallDetail', params: { id: id } });
            window.open(routeData.href, '_blank');
        },
        async search(){
            this.inputs = this.search_input
            let res = await SearchStore({
                searchStr:this.inputs,
            });
            var _this = this;
            if(res.Type == 'Success'){
                this.list = res.Data.list;
                this.keyWordsList = res.Data.keyWords;
            }else{
                this.$message.error(res.Content);
            }
        },
        keyWords(item){
            this.search_input = item
            this.SearchStore()
        },
        async SearchStore(){
            let res = await SearchStore({
                searchStr:this.$route.query.searchStr,
            });
            var _this = this;
            if(res.Type == 'Success'){
                this.list = res.Data.list;
                this.keyWordsList = res.Data.keyWords;
            }else{
                this.$message.error(res.Content);
            }
        },
        async SystemCase(){
            let res = await SystemCase({
                typeId:this.$route.query.id
            });
            if(res.Type == 'Success'){
                this.SystemCaseList = res.Data.goods
                this.keyWordsList = res.Data.keyWords
            }
        }
    },
    created() {
        if(this.$route.query.type == 1){
            this.SystemCase()
            this.keyId = this.$route.query.id
        }else{
            this.search_input = this.$route.query.searchStr
            this.SearchStore()
        }
    }
}
</script>
<style>
.soudiv{cursor: pointer;}
.goods-money span{
    font-size: 15px;
    color: #fff;
    background: #ff5a00;
    padding: 1px 9.5px;
    border-radius: 10px;
    margin-right: 10px;
}
</style>